import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import NotFound from "./NotFound";

export default function Legal({ slug }) {
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false); setPage(null);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <NotFound/>;
  if (!page) return <div className="pt-10 text-center text-zinc-500">Načítání…</div>;

  const desc = (page.content || "").replace(/\*\*/g, "").replace(/\s+/g, " ").trim().slice(0, 160);

  return (
    <div className="pt-8 pb-20" data-testid={`legal-${slug}`}>
      <SEO title={page.title} description={desc} type="article" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="text-sm text-blue-600 mb-6 inline-block">← Domů</Link>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-8">{page.title}</h1>
        <div className="prose prose-zinc max-w-none text-zinc-700 leading-relaxed">
          {page.content.split("\n").map((line, i) => {
            const trimmed = line.trim();
            if (trimmed.startsWith("**") && trimmed.endsWith("**") && trimmed.length > 4) {
              return <h3 key={i} className="font-display font-bold text-xl mt-8 mb-3">{trimmed.replaceAll("**", "")}</h3>;
            }
            // inline bold
            const parts = line.split(/(\*\*[^*]+\*\*)/g).map((p, j) =>
              p.startsWith("**") && p.endsWith("**") ? <strong key={j}>{p.replaceAll("**","")}</strong> : p
            );
            return line ? <p key={i} className="mb-4">{parts}</p> : <br key={i}/>;
          })}
        </div>
      </div>
    </div>
  );
}
